import React from 'react';
import ReactModal from 'react-modal';
import * as S from './Modal.styles';
import CloseIcon from '../images/icons-cerrar-24-px.svg';
import Icon from "../Icon/Icon";

const widthBySize = {
  md: '510px',
};

const Modal = ({
                 children,
                 onDismiss,
                 isOpen,
                 size,
                 showOverlay = true,
                 shouldCloseOnOverlayClick = true,
                 modalMargins,
                 minHeigth,
                 borderRadius
               }) => {
  const sizeMd = size === 'md';
  const modalMarginSize = modalMargins || '10% auto';
  const minHeigthSize = minHeigth || '490px'

  return (
     <ReactModal
        isOpen={isOpen}
        className={`modal-size-${size}`}
        onRequestClose={() => onDismiss && onDismiss(false)}
        style={{
          overlay: {
            background: showOverlay ? 'rgba(0,0,0,0.65)' : 'transparent',
            zIndex: 1,
          },
          content: {
            width: sizeMd && widthBySize[size],
            margin: sizeMd ? '0 auto' : '0 16px',
          },
        }}
        shouldFocusAfterRender={false}
        ariaHideApp={false}
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
     >
       <S.ModalWrapper
          sizeMd={sizeMd}
          modalMarginSize={modalMarginSize}
          minHeigth={minHeigthSize}
          data-testid='modal-wrapper'
          borderRadius={borderRadius}
       >
         <S.ModalContent sizeMd={sizeMd}>{children}</S.ModalContent>
       </S.ModalWrapper>
     </ReactModal>
  );
};

export default Modal;
